export const DEFAULT_TABLE_PAGE_SIZE = 100 as const;

export const LARGE_TABLE_PAGE_SIZE_OPTIONS: number[] = [100, 300, 500, 1000];
